var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-wrap text-center",class:{'full-box display-flex-center justify-content-center': _vm.isFullSize}},[_c('img',{class:{'full-size': _vm.isFullSize},attrs:{"src":_vm.pathView,"alt":"Media"}})])}
var staticRenderFns = []

export { render, staticRenderFns }